import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import * as serviceWorker from "./serviceWorker";
import CombinedContextProvider from "./mobileView/contextProvider";
import { initSentry } from "./sentry";
import ErrorBoundary from "./components/ErrorBoundary";
import OptionalGoogleOAuthProvider from "./components/OptionalGoogleOAuthProvider";

// Crash reporting first, so a throw during the initial render is captured (R29–R34).
initSentry();

ReactDOM.render(
  <ErrorBoundary>
    <OptionalGoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <CombinedContextProvider>
          <App />
        </CombinedContextProvider>
      </Provider>
    </OptionalGoogleOAuthProvider>
  </ErrorBoundary>,
  document.getElementById("root")
);
serviceWorker.unregister();
